import footerLines from '#app/assets/images/decorative/footer-lines.svg'
import logoWhite from '#app/assets/images/logos/100-logo-white.svg'
import technologyWhite from '#app/assets/images/logos/100-technology-white.svg'
import ssnLogo from '#app/assets/images/logos/ssn-logo.svg'
import { cn } from '#app/utils/misc.tsx'
import { Icon } from './ui/icon.tsx'

interface FooterProps {
	className?: string
}

export function Footer({ className }: FooterProps) {
	const currentYear = new Date().getFullYear()

	return (
		<footer
			className={cn('relative overflow-hidden px-0 py-8', className)}
			style={{
				background:
					'linear-gradient(90deg, var(--blue-500) 0%, var(--green-500) 100%)',
			}}
		>
			{/* Background decorative lines - SVG approach recommended */}
			<div className="absolute top-[-451px] left-[-445px] flex h-[1261px] w-[1281px] items-center justify-center">
				<div className="flex-none rotate-[332.702deg]">
					<div className="relative h-[921px] w-[966px] opacity-30">
						<img
							alt=""
							className="block size-full max-w-none"
							src={footerLines}
						/>
					</div>
				</div>
			</div>

			{/* Mobile Layout */}
			<div className="block md:hidden">
				<div className="relative z-10 px-4">
					<div className="mx-auto max-w-[300px]">
						<div className="flex flex-col items-center gap-6">
							{/* Logo Section */}
							<div className="flex w-full items-start justify-between">
								{/* Main Logo */}
								<div className="h-[26px] w-[137px]">
									<img
										src={logoWhite}
										alt="100prevalor"
										className="h-full w-full object-contain"
									/>
								</div>

								{/* Divider Line */}
								<div className="flex h-[26px] w-[2px] items-center justify-center">
									<div className="h-0.5 w-[26px] rotate-90 bg-neutral-100" />
								</div>

								{/* Technology Logo */}
								<div className="h-[39px] w-[129px]">
									<img
										src={technologyWhite}
										alt="100prevalor Technology"
										className="h-full w-full object-contain"
									/>
								</div>
							</div>

							{/* Navigation Menu */}
							<div className="flex w-full flex-col gap-8">
								{/* Seguros Column */}
								<div className="flex w-40 flex-col gap-1">
									<h3 className="font-parkinsans text-base leading-[32px] font-bold text-white">
										Seguros
									</h3>
									<ul className="flex flex-col gap-1">
										<li>
											<a
												href="#"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Personas
											</a>
										</li>
										<li>
											<a
												href="#"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Empresas
											</a>
										</li>
									</ul>
								</div>

								{/* Propósito Column */}
								<div className="flex w-40 flex-col gap-1">
									<h3 className="font-parkinsans text-base leading-[32px] font-bold text-white">
										Propósito
									</h3>
									<ul className="flex flex-col gap-1">
										<li>
											<a
												href="#"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Sobre nosotros
											</a>
										</li>
										<li>
											<a
												href="/programa-madre"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Educa ConCiencia
											</a>
										</li>
										<li>
											<a
												href="#"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Fondo de Agua del Río Mendoza
											</a>
										</li>
										<li>
											<a
												href="#"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Aportar
											</a>
										</li>
									</ul>
								</div>

								{/* Technology Column */}
								<div className="flex w-40 flex-col gap-1">
									<h3 className="font-parkinsans text-base leading-[32px] font-bold text-white">
										Technology
									</h3>
									<ul className="flex flex-col gap-1">
										<li>
											<a
												href="#"
												className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
											>
												Solución
											</a>
										</li>
									</ul>
								</div>
							</div>

							{/* Social Links and Contact Container */}
							<div className="flex w-full flex-col gap-6">
								{/* Social Media Icons */}
								<div className="flex gap-3">
									<a
										href="#"
										className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
										aria-label="Facebook"
									>
										<Icon
											name="facebook-logo"
											className="h-5 w-5 text-green-500"
										/>
									</a>
									<a
										href="#"
										className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
										aria-label="Instagram"
									>
										<Icon
											name="instagram-logo"
											className="h-5 w-5 text-green-500"
										/>
									</a>
									<a
										href="#"
										className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
										aria-label="YouTube"
									>
										<Icon
											name="youtube-logo"
											className="h-5 w-5 text-green-500"
										/>
									</a>
									<a
										href="#"
										className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
										aria-label="LinkedIn"
									>
										<Icon
											name="linkedin-logo"
											className="h-5 w-5 text-green-500"
										/>
									</a>
								</div>

								{/* Contact Information */}
								<div className="flex w-full flex-col gap-3">
									<a
										href="mailto:contacto@100prevalor.com.ar"
										className="font-inter text-base leading-[26px] font-normal text-white transition-colors hover:text-white/80"
									>
										contacto@100prevalor.com.ar
									</a>
									<a
										href="tel:+542617491900"
										className="font-inter text-base leading-[26px] font-normal text-white transition-colors hover:text-white/80"
									>
										(261) 7491900
									</a>
									<a
										href="tel:+5491126242933"
										className="font-inter text-base leading-[26px] font-normal text-white transition-colors hover:text-white/80"
									>
										(11) 2624-2933
									</a>
								</div>
							</div>

							{/* SSN Logo and Matrícula */}
							<div className="flex w-full flex-col items-center justify-center gap-2">
								<div className="h-[39px] w-[236px]">
									<img
										src={ssnLogo}
										alt="SSN"
										className="h-full w-full object-contain"
									/>
								</div>
								<p className="font-inter text-xs leading-[18px] font-medium text-white/70">
									Matrícula SSN N° 1879
								</p>
							</div>

							{/* Bottom Copyright */}
							<div className="flex w-full items-center justify-center">
								<p className="font-inter text-sm leading-[22px] font-medium text-white/80">
									© {currentYear} - 100prevalor
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Desktop Layout */}
			<div className="hidden md:block">
				<div className="relative z-10 container mx-auto max-w-[1200px]">
					<div className="flex h-[315px] flex-col justify-between">
						{/* Main Footer Content */}
						<div className="flex justify-between gap-[70px]">
							{/* Logo Section */}
							<div className="flex flex-col gap-6">
								{/* Main Logo */}
								<div className="h-11 w-[226px]">
									<img
										src={logoWhite}
										alt="100prevalor"
										className="h-full w-full object-contain"
									/>
								</div>

								{/* Divider Line */}
								<div className="h-0.5 w-[75px] bg-neutral-100" />

								{/* Technology Logo */}
								<div className="h-[68px] w-[226px]">
									<img
										src={technologyWhite}
										alt="100prevalor Technology"
										className="h-full w-full object-contain"
									/>
								</div>
							</div>

							{/* Navigation and Contact Section */}
							<div className="flex flex-1 justify-end gap-6">
								{/* Navigation Menu */}
								<div className="flex gap-8">
									{/* Seguros Column */}
									<div className="flex w-40 flex-col gap-6">
										<h3 className="font-parkinsans text-base leading-[32px] font-bold text-white">
											Seguros
										</h3>
										<ul className="space-y-6">
											<li>
												<a
													href="#"
													className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
												>
													Empresas
												</a>
											</li>
										</ul>
									</div>

									{/* Propósito Column */}
									<div className="flex w-40 flex-col gap-6">
										<h3 className="font-parkinsans text-base leading-[32px] font-bold text-white">
											Propósito
										</h3>
										<ul className="space-y-6">
											<li>
												<a
													href="#"
													className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
												>
													Sobre nosotros
												</a>
											</li>
											<li>
												<a
													href="#"
													className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
												>
													Educa ConCiencia
												</a>
											</li>
											<li>
												<a
													href="#"
													className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
												>
													Fondo de Agua
												</a>
											</li>
											<li>
												<a
													href="#"
													className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
												>
													Aportar
												</a>
											</li>
										</ul>
									</div>

									{/* Technology Column */}
									<div className="flex w-40 flex-col gap-6">
										<h3 className="font-parkinsans text-base leading-[32px] font-bold text-white">
											Technology
										</h3>
										<ul className="space-y-6">
											<li>
												<a
													href="#"
													className="font-inter text-sm leading-[22px] font-medium text-white/80 transition-colors hover:text-white"
												>
													Solución
												</a>
											</li>
										</ul>
									</div>
								</div>

								{/* Social Links and Contact */}
								<div className="flex w-[236px] flex-col gap-6">
									{/* Social Media Icons */}
									<div className="flex gap-3">
										<a
											href="#"
											className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
											aria-label="Facebook"
										>
											<Icon
												name="facebook-logo"
												className="h-5 w-5 text-green-500"
											/>
										</a>
										<a
											href="#"
											className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
											aria-label="Instagram"
										>
											<Icon
												name="instagram-logo"
												className="h-5 w-5 text-green-500"
											/>
										</a>
										<a
											href="#"
											className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
											aria-label="YouTube"
										>
											<Icon
												name="youtube-logo"
												className="h-5 w-5 text-green-500"
											/>
										</a>
										<a
											href="#"
											className="flex items-center justify-center rounded-xl bg-green-50 p-3 transition-colors hover:bg-green-100"
											aria-label="LinkedIn"
										>
											<Icon
												name="linkedin-logo"
												className="h-5 w-5 text-green-500"
											/>
										</a>
									</div>

									{/* Contact Information */}
									<div className="flex flex-col gap-1">
										<a
											href="mailto:contacto@100prevalor.com.ar"
											className="font-inter text-base leading-[26px] font-normal text-white transition-colors hover:text-white/80"
										>
											contacto@100prevalor.com.ar
										</a>
										<a
											href="tel:+542617491900"
											className="font-inter text-base leading-[26px] font-normal text-white transition-colors hover:text-white/80"
										>
											(261) 749-1900
										</a>
										<a
											href="tel:+5491126242933"
											className="font-inter text-base leading-[26px] font-normal text-white transition-colors hover:text-white/80"
										>
											(11) 2624-2933
										</a>
									</div>
								</div>
							</div>
						</div>

						{/* SSN Logo and Matrícula - Following Figma structure */}
						<div className="flex w-full items-center justify-end gap-2">
							<p className="font-inter text-xs leading-[18px] font-medium text-white/70">
								Matrícula SSN N° 1879
							</p>
							<div className="h-[38px] w-[230px] shrink-0">
								<img
									src={ssnLogo}
									alt="SSN"
									className="h-full w-full object-contain"
								/>
							</div>
						</div>

						{/* Bottom Copyright */}
						<div className="flex w-full items-center justify-end gap-[539px]">
							<p className="font-inter text-sm leading-[22px] font-medium whitespace-pre text-white/80">
								© {currentYear} - 100prevalor
							</p>
						</div>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
